import { render, staticRenderFns } from "./TwitterCard.vue?vue&type=template&id=7634ca7c&scoped=true&"
import script from "./TwitterCard.vue?vue&type=script&lang=js&"
export * from "./TwitterCard.vue?vue&type=script&lang=js&"
import style0 from "./TwitterCard.vue?vue&type=style&index=0&id=7634ca7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634ca7c",
  null
  
)

export default component.exports